import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'

const childrenIndentCss = css`
  margin-inline-start: 27px;
  padding: 4px 15px;
  background: ${colors.gray02};
  border-inline-start: 1px solid ${colors.gray10};
  border-bottom: 1px solid ${colors.gray10};
  border-inline-end: 1px solid ${colors.gray10};
  border-end-start-radius: 8px;
  border-end-end-radius: 8px;
`

type Props = {
  children: ReactNode
}

export default function ChildrenWrapper({ children }: Props): JSX.Element {
  return <div css={childrenIndentCss}>{children}</div>
}
